



















































































import { Component, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import LanguagesStore from "@/mixins/constants/languagesStore";
import { ILanguage } from "@/models/constants";
import { SupportedLocaleCodes } from "@/data/enums/i18n";

interface Form {
  name: string;
  email: string;
  document_language_code: ILanguage["code"];
  interface_language_code: ILanguage["code"];
}

const initialForm = (): Form => {
  return {
    name: "",
    email: "",
    interface_language_code: SupportedLocaleCodes.EN,
    document_language_code: SupportedLocaleCodes.EN
  };
};

@Component
export default class AddUserModal extends Mixins(
  RequestPromises,
  LanguagesStore,
  HasValidation
) {
  public declare $refs: {
    name: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };
  public form: Form = initialForm();
  public initialForm: Form = initialForm();
  public isProcessing = false;

  public mounted() {
    this.$nextTick(() => this.$refs.name.focus());
  }

  public async validateBeforeSubmit() {
    if (!this.canCreate) {
      return;
    }
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      const user = await this.createUser();
      this.$buefy.toast.open({
        message: this.$t("_.object_successfully_created", {
          object: this.$t("_.staff_user") as string
        }) as string
      });
      this.$router.push({
        name: "adminUser",
        params: { userId: user.id }
      });
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public createUser() {
    this.form.document_language_code = this.form.interface_language_code;
    return this.$store.dispatch(`data/${DataModules.USERS}/create`, {
      data: this.form
    });
  }

  public get isFormChanged(): boolean {
    return this.$_.isEqual(this.form, this.initialForm);
  }

  public get canCreate() {
    return this.$userCan("create_user");
  }
}
